import React, { Component } from 'react';
import { connect } from 'react-redux';
import { log } from '../../util/api';
import { Btn, IconBtn, Card, PageHead, SearchInput, Select, Badge, Stat, Empty, Loading, Modal, ConfirmModal, Pager, COLORS, notify, num, paginate, searchMatch, phoneOf } from './ui';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import moment from 'moment';

class HistoryTable extends Component {
	state = {
		loading: true,
	};
	componentDidMount() {
		this.getLogs();
	}

	async getLogs() {
		let { product } = this.props;
		let pid = product.id;
		await log('/api/listSchedules', { pid, limit: 20 })
			.then((data) => {
				let response = data.data && data.data.result;
				this.setState({ logData: response, loading: false });
			})
			.catch(() => this.setState({ loading: false }));
	}
	closeModal = () => {
		this.setState({ openModal: false });
	};
	exportExcel = async () => {
		this.setState({ buttonLoading: true });
		let { product } = this.props;
		let pid = product.id;
		let { details, selected, selectedDate } = this.state;

		let sent_list = _.filter(details, { status: 'sent' });
		let delivered_list = _.filter(details, { status: 'delivered' });
		let read_list = _.filter(details, { status: 'read' });
		let excel_data = _.map(selected, (o) => {
			let phone_number = /@/.test(o.id) ? o.id.replace(/@.*/, '') : o.id;
			let rgx = new RegExp(phone_number);

			let isRead = _.find(read_list, (it) => rgx.test(it.phone_id));
			let isDelivered = isRead || _.find(delivered_list, (it) => rgx.test(it.phone_id));
			let isSent = isDelivered || _.find(sent_list, (it) => rgx.test(it.phone_id));

			return {
				İsim: o.name,
				Telefon: phone_number,
				'Gönderen Telefon': o.phone,
				Gönderildi: '' + !!isSent,
				Ulaştı: '' + !!isDelivered,
				Okundu: '' + !!isRead,
			};
		});
		//console.log(excel_data, selectedDate);
		let sheets = [
			{
				name: 'message_analytic',
				x: ['İsim', 'Telefon', 'Gönderen Telefon', 'Gönderildi', 'Ulaştı', 'Okundu'],
				datasets: excel_data,
			},
		];
		await fetch('https://log.yapaytech.com/analytic/download', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				filename: moment(selectedDate).format('DD_MM_YYYY_HH_mm_ss') + '_broadcast_message_' + pid,
				sheets,
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let dataurl = data.url;
				var a = document.createElement('a');
				a.href = dataurl;
				a.setAttribute('download', dataurl);
				a.click();
				this.setState({ buttonLoading: false });
			});
	};
	async getDetail(log, groups, date) {
		this.setState({ btnRefresh: true });
		let { product } = this.props;
		//let pid = product.id;
		let live_pid = product.settings.live.token;
		if (!log) return;
		await fetch('https://live.dahi.ai/analytics/dialogtab/broadcastResult ', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				template_name: (log.template && log.template.value) || log.message,
				list: 'uid',
				pid: live_pid,
				start_date: moment(date).add('-3', 'h'),
				end_date: moment(date).add('5', 'h'),
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let list = [];
				_.map(data.data, (it) =>
					_.map(it.list, (o) => {
						o.status = it._id;
						list.push(o);
					})
				);
				this.setState({
					details: list,
					detailList: data.data,
				});
			});
		console.log('log', log);
		this.setState({ openModal: true, selected: groups, selectedLog: log, selectedDate: date, btnRefresh: false });
	}
	async cancelSchedule() {
		let job_id = this.state.selectedJobId;
		let { product } = this.props;
		let pid = product.id;

		this.setState({ cancelling: true });
		await log('/api/addSchedule', {
			category: 'schedule',
			label: 'broadcast_cancel_event',
			extra: { job_id },
			pid,
		})
			.then(() => {
				this.setState({ openCancel: false, cancelling: false });
				notify(this.props.t('Planlanmış gönderim iptal edildi.'));
				this.getLogs();
			})
			.catch(() => {
				this.setState({ cancelling: false });
				notify(this.props.t('İptal edilemedi, tekrar deneyin.'), 'err');
			});
	}

	render() {
		let { logData, loading, openModal, selected, selectedLog, q, stateFilter, page = 1 } = this.state;
		let { t } = this.props;
		if (loading) return <Loading />;
		let messageTypes = [
			{ value: 'text', text: t('Yazı') },
			{ value: 'media', text: t('Medya') },
			{ value: 'link', text: t('Link') },
			{ value: 'document', text: t('document') },
			{ value: 'template', text: 'Template' },
			{ value: 'audio', text: t('audio') },
			{ value: 'image', text: t('Medya') },
			{ value: 'video', text: t('Medya') },
			{ value: 'gif', text: 'Gif' },
			{ value: 'sticker', text: 'Sticker' },
		];
		let STATES = {
			created: { label: t('Bekliyor'), tone: 'info' },
			retry: { label: t('Yeniden denenecek'), tone: 'warn' },
			active: { label: t('Gönderiliyor'), tone: 'purple' },
			completed: { label: t('Tamamlandı'), tone: 'ok' },
			cancelled: { label: t('İptal edildi'), tone: 'muted' },
			failed: { label: t('Hatalı'), tone: 'danger' },
			expired: { label: t('Süresi doldu'), tone: 'danger' },
		};
		let stateOf = (s) => STATES[s] || { label: t(s), tone: 'muted' };
		let typeText = (extra) => {
			if (extra.template && extra.template.value) return 'Template';
			let ty = extra.content && _.find(messageTypes, { value: extra.content.type });
			return (ty && ty.text) || t('Hatalı');
		};
		let messageText = (extra) =>
			extra.template && extra.template.value
				? extra.template.value
				: extra.content && extra.content.imageUrl
				? extra.content.imageUrl + (extra.content.text ? ' - ' + extra.content.text : '')
				: (extra.content && (extra.content.text || extra.content.url)) || '';
		let items = _.filter(logData, (obj) => obj.data && obj.data.event && obj.data.event.extra);
		let counts = _.countBy(items, 'state');
		let rows = _.filter(items, (obj) => {
			let extra = obj.data.event.extra;
			if (stateFilter && obj.state !== stateFilter) return false;
			return searchMatch(q, messageText(extra), extra.message_name, extra.shop);
		});
		return (
			<div>
				<PageHead
					title={t('Planlanmış gönderimler')}
					desc={t('Son 20 gönderim emri. Henüz başlamamış ileri tarihli gönderimleri iptal edebilirsiniz.')}
					right={
						<Btn variant="ghost" icon="refresh" onClick={() => this.setState({ loading: true }, () => this.getLogs())}>
							{t('Yenile')}
						</Btn>
					}
				/>
				<div className="wsm-stats">
					<Stat label={t('Toplam')} value={num(items.length)} active={!stateFilter} onClick={() => this.setState({ stateFilter: '', page: 1 })} />
					<Stat label={t('Bekliyor')} value={num(counts.created)} color={COLORS.info} active={stateFilter === 'created'} onClick={() => this.setState({ stateFilter: 'created', page: 1 })} />
					<Stat label={t('Gönderiliyor')} value={num(counts.active)} color={COLORS.purple} active={stateFilter === 'active'} onClick={() => this.setState({ stateFilter: 'active', page: 1 })} />
					<Stat label={t('Tamamlandı')} value={num(counts.completed)} color={COLORS.primary} active={stateFilter === 'completed'} onClick={() => this.setState({ stateFilter: 'completed', page: 1 })} />
					<Stat label={t('İptal / hata')} value={num((counts.cancelled || 0) + (counts.failed || 0) + (counts.expired || 0))} color={COLORS.danger} />
				</div>
				<Card>
					<div className="wsm-section">
						<div className="wsm-row" style={{ gap: 10 }}>
							<SearchInput value={q} onChange={(v) => this.setState({ q: v, page: 1 })} placeholder={t('Mesaj, şablon veya kampanya ara…')} />
							<Select
								auto
								value={stateFilter || ''}
								options={[{ value: '', label: t('Durum') + ': ' + t('Hepsi') }].concat(_.map(STATES, (v, k) => ({ value: k, label: v.label })))}
								onChange={(v) => this.setState({ stateFilter: v, page: 1 })}
							/>
						</div>
					</div>
					{!items.length ? (
						<Empty compact icon="calendar" title={t('Planlanmış gönderim yok')} desc={t('Mesaj Gönder sekmesinde "İleri tarihli" seçerek gönderim planlayabilirsiniz.')} />
					) : (
						<>
							<div className="wsm-table-wrap">
								<table className="wsm-table" style={{ minWidth: 760 }}>
									<thead>
										<tr>
											<th>{t('message')}</th>
											<th>{t('type')}</th>
											<th>{t('Gönderim zamanı')}</th>
											<th className="r">{t('Alıcı')}</th>
											<th>{t('status')}</th>
											<th className="r">{t('İşlem')}</th>
										</tr>
									</thead>
									<tbody>
										{paginate(rows, page, 20).map((obj, i) => {
											let extra = obj.data.event.extra;
											let groups = _.map(extra.numbers, (it) => it);
											let st = stateOf(obj.state);
											return (
												<tr key={obj.job_id || i}>
													<td>
														<div className="wsm-ellipsis" style={{ fontWeight: 600 }} title={messageText(extra)}>
															{messageText(extra) || '—'}
														</div>
														{extra.message_name || extra.shop ? <div className="wsm-hint">{_.compact([extra.message_name, extra.shop]).join(' · ')}</div> : null}
													</td>
													<td className="wsm-muted">{typeText(extra)}</td>
													<td className="wsm-muted wsm-nowrap">{moment(obj.startafter).format('DD.MM.YYYY HH:mm')}</td>
													<td className="r">{num(groups.length)}</td>
													<td>
														<Badge tone={st.tone}>{st.label}</Badge>
													</td>
													<td className="r">
														<div className="wsm-row" style={{ justifyContent: 'flex-end', gap: 6, flexWrap: 'nowrap' }}>
															<IconBtn icon="eye" title={t('Alıcıları gör')} onClick={() => this.getDetail(extra, groups, obj.startafter)} />
															{obj.state === 'created' ? (
																<IconBtn icon="x" danger title={t('cancel')} onClick={() => this.setState({ openCancel: true, selectedJobId: obj.job_id })} />
															) : null}
														</div>
													</td>
												</tr>
											);
										})}
										{!rows.length ? (
											<tr>
												<td colSpan={6} className="wsm-empty-row">
													{t('Filtrelerle eşleşen kayıt yok.')}
												</td>
											</tr>
										) : null}
									</tbody>
								</table>
							</div>
							<Pager page={page} pageSize={20} total={rows.length} onChange={(p) => this.setState({ page: p })} label={`${num(rows.length)} ${t('kayıt')}`} />
						</>
					)}
				</Card>
				{selectedLog && openModal ? (
					<Modal
						title={t('numbers') + ` (${num((selected || []).length)})`}
						desc={`${messageText(selectedLog) || '—'} · ${typeText(selectedLog)}`}
						icon="users"
						width={640}
						onClose={this.closeModal}
						bodyStyle={{ padding: 0 }}
					>
						<table className="wsm-table">
							<thead>
								<tr>
									<th>{t('name')}</th>
									<th>{t('phone')}</th>
								</tr>
							</thead>
							<tbody>
								{_.map(selected, (it, i) => (
									<tr key={i}>
										<td>{it.name || it.id}</td>
										<td className="wsm-muted">{phoneOf(it.id)}</td>
									</tr>
								))}
							</tbody>
						</table>
					</Modal>
				) : null}
				{this.state.openCancel ? (
					<ConfirmModal
						title={t('Gönderimi iptal et')}
						body={t('Planlanmış gönderimi iptal etmek istediğinize emin misiniz?')}
						confirmText={t('yes')}
						cancelText={t('no')}
						busy={this.state.cancelling}
						onClose={() => this.setState({ openCancel: false })}
						onConfirm={() => this.cancelSchedule()}
					/>
				) : null}
			</div>
		);
	}
}

const stateToProps = (state) => ({
	access: state.access,
	location: state.router.location,
	product: state.product.live,
	user: state.access.user.loggedUserObj,
});
export default connect(stateToProps)(withTranslation()(HistoryTable));
